"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "GradientCarousel", {
  enumerable: true,
  get: function () {
    return _GradientCarouselSection.default;
  }
});
var _GradientCarouselSection = _interopRequireDefault(require("./GradientCarouselSection"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }